import { render, staticRenderFns } from "./Batiment.vue?vue&type=template&id=1c8507dc&"
import script from "./Batiment.vue?vue&type=script&lang=ts&"
export * from "./Batiment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports